function createNeverResolvingPromise<T = unknown>() {
    return new Promise(() => {}) as Promise<T>;
}

export function sleep(durationInMs: number) {
    // Check for Infinity
    if (durationInMs > 0 && !isFinite(durationInMs)) {
        return createNeverResolvingPromise<void>();
    }

    return new Promise<void>(resolve => {
        setTimeout(() => {
            resolve();
        }, durationInMs);
    });
}
